import RestClient from '../../config/rest-client';

export async function getQuestions(id) {
  try {
    const data = await RestClient.findOne('question-learning/view', id);
    return data;
  } catch (error) {
    return {
      category: null,
      questions: []
    }
  }
}

